// extracted by mini-css-extract-plugin
export var header = "_b2-0";